export const aciClip = {
    iconName: 'clip',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M18 15.332V8A6 6 0 106 8v10a4 4 0 108 0V8a2 2 0 10-4 0v8.667',
                stroke: 'currentColor',
                'stroke-width': '1.215',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
